import { FC } from 'react';
import { styled, Typography, Box, CircularProgress } from '@mui/material';
import { CSSObject } from 'styled-components';
import { colors } from 'assets/styles/AMBGTheme';

interface IProps {
	loaderMessage?: string;
	isLeftAlign?: boolean;
}

const loaderWrapperStyles: CSSObject = {
	width: '100%',
	height: '100%',
	minHeight: '200px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center'
};

const StyledTypography = styled(Typography)({
	marginTop: '10px',
	fontSize: '20px',
	color: colors.black.main
}) as typeof Typography;

const AMBGLoader: FC<IProps> = (props) => {
	const { loaderMessage } = props;

	return (
		<Box
			sx={
				props.isLeftAlign === true
					? { ...loaderWrapperStyles, marginLeft: '8%', alignItems: 'flex-start' }
					: loaderWrapperStyles
			}
		>
			<CircularProgress data-testid='loader' color='primary' />
			{loaderMessage && (
				<StyledTypography data-testid='loaderMessage' className='loader-message'>
					{loaderMessage}
				</StyledTypography>
			)}
		</Box>
	);
};

export default AMBGLoader;
